module.exports = __webpack_public_path__ + "static/the-wisdom-of-crowds-ab7b808b1d8e664c4524c83871a283f5.jpg";